import * as componentModels from '../models/componentModels';

export function getMenuComponentByType(menu_type){
    const menu = componentModels.MENU_TYPES.filter(menu => menu.constant == menu_type);
    if (menu) return menu[0]; //since filter returns an array, have to grab the first.
    return null;
}


export function getBiteComponentByType(bite_type){
    const bite = componentModels.BITE_TYPES.filter(bite => bite.constant == bite_type);
    if (bite) return bite[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getScreenComponentByType(screen_type){
    const screen = componentModels.SCREEN_TYPES.filter(screen => screen.constant == screen_type);
    if (screen) return screen[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getSubTitleScreenComponentByType(screen_type){
    const sub_screen = componentModels.TITLE_SCREEN_SUB_TYPES.filter(sub_screen => sub_screen.constant == screen_type);
    if (sub_screen) return sub_screen[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getDefaultSubTitleScreenComponent(){
    const sub_screen = componentModels.TITLE_SCREEN_SUB_TYPES.filter(sub_screen => sub_screen.isDefault);
    if (sub_screen) return sub_screen[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getAssetComponentByType(asset_type){
    const asset = componentModels.ASSET_TYPES.filter(asset => asset.constant == asset_type);
    if (asset) return asset[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getChildObjectComponentByType(asset_type_code){
    const object = componentModels.CHILD_OBJECTS_TYPES.filter(object => object.constant == asset_type_code);
    if (object) return object[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getResourceLinkComponentByType(object_type){
    const object = componentModels.RESOURCE_LINK_TYPES.filter(object => object.constant == object_type);
    if (object) return object[0]; //since filter returns an array, have to grab the first.
    return null;
}
/*
export function getToolboxComponentByType(asset_type_code){
    const object = componentModels.TOOLBOX_TYPES.filter(object => object.constant == asset_type_code);
    if (object) return object[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getToolboxScreenComponentByType(asset_type_code){
    const object = componentModels.TOOLBOX_SCREEN_TYPES.filter(object => object.constant == asset_type_code);
    if (object) return object[0]; //since filter returns an array, have to grab the first.
    return null;
}*/


/** WEBPACK FOOTER **
 ** ./src/helpers/componentHelper.js
 **/